import React, { useMemo } from "react";
import "./SntRadio.scss";

interface SntRadioProps {
  value?: string | number;
  label?: React.ReactNode;
  selectedValue?: string | number;
  disabled?: boolean;
  onChange?: (value?: string) => void;
  className?: string;
}

function SntRadio({
  value,
  label,
  selectedValue,
  disabled = false,
  onChange,
  className,
}: SntRadioProps) {
  const isChecked = value === selectedValue;

  const radioClassName = useMemo(() => {
    const classes = ["snt-radio"];
    if (isChecked) classes.push("snt-radio--checked");
    if (disabled) classes.push("snt-radio--disabled");
    return classes.join(" ");
  }, [isChecked, disabled]);

  function onClick() {
    if (!disabled) {
      onChange?.(value?.toString());
    }
  }

  return (
    <div className="d-inline-block">
      <div
        className={`d-flex ${className ?? ""}`}
        onClick={onClick}
        style={{ cursor: disabled ? "default" : "pointer" }}
      >
        <div className="me-3">
          <div className={radioClassName} />
        </div>
        <div className="align-middle">{label ?? ""}</div>
      </div>
    </div>
  );
}

export default SntRadio;
